import React, { Component } from "react";
import { withAuth } from "../providers/AuthProvider";


class Login extends Component {
  constructor(props) {
    super(props)
    this.state = {
      username: "",
      password: ""
    };
  }

  handleFormSubmit = event => {
    event.preventDefault();
    const { username, password } = this.state;
    this.props.login({
      username, 
      password
    })
  };

  handleChange = event => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  render() {
    const { username, password } = this.state;
    return (
      <div className="main h-2/3">
        <form onSubmit={this.handleFormSubmit} className="flex flex-col w-80 m-auto pt-10">
          <label>Username:</label>
          <input
            type="text"
            name="username"
            value={username}
            className="formInput"
            onChange={this.handleChange}
          />
          <label>Password:</label>
          <input
            type="password"
            name="password"
            value={password}
            className="formInput"
            onChange={this.handleChange}
          />
          <input type="submit" className="button" value="Login" />
        </form>
      </div>
    );
  }
}

export default withAuth(Login);
